import { useStaticQuery, graphql } from "gatsby";
const useQuizQuery = () => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      wpPage(title: { eq: "Quiz" }) {
        disclaimer {
          disclaimer
        }

        quiz {
          quizQuesitionAndAnswer {
            quizQuestion
            quizAnswers {
              choice
              choiceValue
              toolTip
              tooltipShow
            }
            questionType
            selected
            textValue
          }
        }
        quizResult {
          quizResult {
            description
            result
            score
            scoreFrom
            scoreTo
            color
          }
        }
      }
    }
  `);

  return data;
};

export default useQuizQuery;
